import React, { useCallback, useEffect, useRef, useState } from 'react'
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { useFocusEffect } from '@react-navigation/native';
import { PrivateStackParamList } from "@routes/types";
import ScreenWrapper from "@hoc/ScreenWrapper";
import Stepper from "@sharedComponents/Stepper/Stepper";
import CommonHeader from "@sharedComponents/Header/Header";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import { Theme, ThemedText, ThemedView } from '@app/theme';
import Button from "@sharedComponents/Button/Button";
import { useTheme } from "@shopify/restyle";
import DigiLockerIcon from "@app/assets/svg/DigiLockerIcon";
import KYCFastSecure from "@app/assets/svg/KYCFastSecure";
import KYCInstantAadharPull from "@app/assets/svg/KYCInstantAadharPull";
import KYCGovtOfIndia from "@app/assets/svg/KYCGovtOfIndia";
import { updateCurrentStepId, updateLinkedApplication } from "@app/store/slices/authSlice";

import {
    digioUtils, getKYCMode,
    ImportScript,
    invokeDigio,
    kycDSPInitiate, kycDSPInitiateV2,
    kycDSPStatus,
    kycDSPV2Status,
    kycTATAInitiate,
    kycTATAInitiateURL,
    kycTATAStatus,
} from '@screens/KYC/KYCDocuments/services/kycDocumentsService';
import { DIGIO_SCRIPT } from "@screens/KYC/KYCDocuments/enums/enums";
import { LENDER_ID } from '@types/regix';
import { getParameters, trackEvent } from "@app/utils";
import { KYC_ERROR_MAP, KYC_RESPONSE_STATUS } from "@screens/KYC/utils";
import KYCErrorCard from './components/KYCErrorCard';
import SuccessCard from './components/SuccessCard';
import InProgressCard from './components/InProgressCard';
import { useStepperData } from "@hooks/useStepperData";
import PageLoader from "@sharedComponents/PageLoader/PageLoader";
import { useSuccessLottie } from "@hooks/useSuccessLottie";
import { useLenderInfo } from '@app/hooks/useLenderInfo';
import { Dimensions, ActivityIndicator, Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { postDSPMesage } from '@app/screens/DigioMandate/util';
import handleApiErr from '@app/helper/handleApiErr';
import { showErrorSheet } from '@app/store/slices/errorSlice';
import { updatePartnerParams } from '@app/store/slices/platformSlice';
import { DIGIO_ENVIRONMENT } from '@app/api/apis';
import DigioMobileIntegration from '@app/sharedComponents/kycDigiLocker/DigioMobileIntegration';
import BottomSheetContainer from "@sharedComponents/Bottomsheet/Bottomsheet";
let statusIntervalTATA: NodeJS.Timeout | undefined;
import WebView from 'react-native-webview';
import ROUTE from '@app/navigationApp/routes';

declare global {
    interface Window {
        digio?: any;
    }
}

type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'KYC_DOCUMENTS'>;

interface KYCDigioTokens {
    identifier?: string;
    requestId?: string;
    tokenId?: string;
    uri?: string;
}


const KYCDocuments = ({ navigation, route }: ScreenProps) => {
    const { userDetails } = useAppSelector(state => state.auth)
    const { stepperData, isLoading: stepperLoading } = useStepperData();
    const { colors } = useTheme<Theme>()
    const currentApplicationId = useAppSelector(state => state.auth?.userDetails?.linkedApplications[0]?.applicationId);
    const [ctaLoader, setCTALoader] = useState(false)
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [frameUrl, setFrameUrl] = useState("")
    const [deepcheckApiInProgress,setDeepcheckApiInProgress] = useState(false)
    const [digioInitResponse, setDigioInitResponseTokens] = useState<KYCDigioTokens | null>(null)
    const digioInvokedRef = useRef(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorRetryCount,setErrorRetryCount] = useState(0)
    const [showInProgressCard, setShowInProgressCard] = useState(false)
    const { lenderInfo, isLoading: lenderInfoLoading } = useLenderInfo();


    const {
        showFailureCard
    } = route.params || false;

    const [showKYCErrorCard, setShowKYCErrorCard] = useState(showFailureCard || false);
    const [failedTitle, setFailedTitle] = useState<string | undefined>(route.params?.failedTitle);
    const [failedSubTitle, setFailedSubTitle] = useState<string | undefined>(route.params?.failedSubTitle);
    const [showSuccessCard, setShowSuccessCard] = useState<boolean | undefined>(route?.params?.showSuccessCard)
    const [nextStepId, setNextStepId] = useState('')
    const lenderId = userDetails?.linkedApplications[0]?.lenderAccountId.toUpperCase()
    const { lottie: successLottie } = useSuccessLottie();
    const isLenderDSP = userDetails?.linkedApplications[0]?.lenderAccountId?.toLowerCase() === LENDER_ID.DSP;
    const dispatch = useAppDispatch();
    // Store interval references to clear them when screen loses focus
    const statusIntervalRef = useRef<number | undefined>();
    const pollIntervalRef = useRef<number | undefined>();
    const digioPollingIntervalRef = useRef<NodeJS.Timeout | undefined>();

    const continueCtaRef = useRef<NodeJS.Timeout | undefined>();

    

    useEffect(() => {
        if (Platform.OS === 'web' && isLenderDSP) {
            postDSPMesage();
        }
    }, [isLenderDSP]);

    useFocusEffect(
        React.useCallback(() => {
            return () => {
                // Clear all intervals when screen loses focus
                if (pollIntervalRef.current) {
                    clearInterval(pollIntervalRef.current);
                    pollIntervalRef.current = undefined;
                }
                if (digioPollingIntervalRef.current) {
                    clearInterval(digioPollingIntervalRef.current);
                    digioPollingIntervalRef.current = undefined;
                }
            };
        }, [])
    );



    useEffect(() => {
        const handleMessage = async (event) => {


            console.log("Message received from iframe:", event.data);

            let data

            try {
                data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;

                 if(data.event === 'backBtnClicked'){
                       navigation.goBack()

                 }
                if (data?.success === true || data?.success === "true") {
                        setFrameUrl("")
                        setDeepcheckApiInProgress(true)
                    try {
                        const response = await kycDSPV2Status({
                            applicationId: userDetails?.linkedApplications[0]?.applicationId
                        });

                    setDeepcheckApiInProgress(false)
                        const status = response?.data?.stepResponseObject;
                        if (status === KYC_RESPONSE_STATUS.COMPLETED) {
                            if (digioPollingIntervalRef.current) {
                                clearInterval(digioPollingIntervalRef.current);
                                digioPollingIntervalRef.current = undefined;
                            }
                            setShowInProgressCard(false);
                            // navigate to next step
                            setShowSuccessCard(true);
                            const nextStepId = response?.data?.updatedApplicationObj?.currentStepId;
                            if (nextStepId && nextStepId !== 'KYC_DOCUMENTS') {
                                setNextStepId(nextStepId);
                                // navigation.navigate(nextStepId);
                            }
                        }
                        setCTALoader(false);
                    } catch (error: any) {
                        clearInterval(digioPollingIntervalRef.current);
                        setShowInProgressCard(false);
                    setDeepcheckApiInProgress(false)

                        if (handleApiErr(error)) {
                            dispatch(showErrorSheet({
                                isErrorSheetVisible: true,
                                errorMessage: error?.data?.message,
                                closeOnBackdropPress: true,
                                errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                                errorHeading: error?.data?.header,
                                showErrorHeading: true,
                                btnName: 'Ok, got it!',
                            }))
                        }
                        setCTALoader(false);
                        console.error('Polling error:', error);
                    }


                }



                if (event.data.type === "customEvent") {
                    console.log("Custom event data:", event.data.payload);
                }

            } catch (error) {
                setDeepcheckApiInProgress(false)

                
            }


        };
        if(Platform.OS === 'web') {
        window?.addEventListener("message", handleMessage);

        }

        return () => {
        if(Platform.OS === 'web') {
            window?.removeEventListener("message", handleMessage);
        }

            if (digioPollingIntervalRef.current) {
                clearInterval(digioPollingIntervalRef.current);
                digioPollingIntervalRef.current = undefined;
            }
        };
    }, [])

    useEffect(() => {
        dispatch(updatePartnerParams({ showCall: true }))
    }, [])

    // Call kycDSPInitiateV2 on screen load if lender is DSP
    useEffect(() => {
        const callDSPInitiateV2 = async () => {
            // Check if we have any route params that indicate we're coming from redirect/response screens
            const hasRouteParams = route?.params && Object.keys(route.params).length > 0;
                        setIsPageLoading(true);

            if (lenderId === LENDER_ID.DSP.toUpperCase() && !hasRouteParams) {
                try {
                    const applicationId = await AsyncStorage.getItem('application_id') ?? currentApplicationId;
                    const kycMode = await getKYCMode({ applicationId: applicationId });

                    if (kycMode?.data === "DSP_URL") {
                        const kycInitiateResponse = await kycDSPInitiateV2({ applicationId: applicationId });
                        const url = kycInitiateResponse?.data?.stepResponseObject?.webUrl;
                        setFrameUrl(url)
                        setIsPageLoading(false)
                    }
                } catch (error: any) {
                    console.error('Error calling kycDSPInitiateV2 on load:', error);
                    if (handleApiErr(error)) {
                        dispatch(showErrorSheet({
                            isErrorSheetVisible: true,
                            errorMessage: error?.data?.message,
                            closeOnBackdropPress: true,
                            errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                            routeName: route?.name,
                            errorHeading: error?.data?.header,
                            ctaLabel: 'Ok, got it'
                        }))
                    }
                }
                finally {
                    setIsPageLoading(false)
                }
            } else {
                setIsPageLoading(false)
            }
        };

        callDSPInitiateV2();
    }, [lenderId, currentApplicationId, route?.params]);

    useEffect(() => {
        if (showSuccessCard) {
            continueCtaRef.current = setTimeout(() => {
                setShowSuccessCard(false)
                if (Platform.OS !== 'web') {
                    //@ts-ignore
                    nextStepId &&
                        navigation.reset({
                            index: 0,
                            routes: [{ name: 'HOME' }, { name: 'KYC_STEPPER' }, { name: nextStepId || route?.params?.currentStepId }]
                        })
                } else {
                    //@ts-ignore
                    navigation.navigate(nextStepId || route?.params?.currentStepId)
                }
            }, 3000)
        }
    }, [showSuccessCard, nextStepId]);

    const handleContinueClick = () => {
        setShowSuccessCard(false)
        if (Platform.OS !== 'web') {
            if (continueCtaRef?.current) {
                clearTimeout(continueCtaRef.current);
                continueCtaRef.current = undefined;
            }
            navigation.reset({
                index: 0,
                routes: [{ name: 'KYC_STEPPER' }, { name: nextStepId || route?.params?.currentStepId }]
            })

        } else {
            //@ts-ignore
            navigation.navigate(nextStepId || route?.params?.currentStepId)
        }
    }

    const showCancelledCard = useCallback(() => {
        //   if (Platform.OS === 'web') {
        setFailedTitle("KYC Verification cancelled");
        setCTALoader(false);
        setFailedSubTitle("You closed the verification window before completing KYC. Please try again.");
        setShowKYCErrorCard(true);
        //   }
    }, [])

    const successCallBackDSP = async () => {
        setShowInProgressCard(true);
        try {
            const response = await kycDSPStatus({
                applicationId: userDetails?.linkedApplications[0]?.applicationId
            });
            dispatch(updateCurrentStepId(response?.data?.updatedApplicationObj?.currentStepId))
            const status = response?.data?.stepResponseObject;
            if (status === KYC_RESPONSE_STATUS.COMPLETED) {
                if (digioPollingIntervalRef.current) {
                    clearInterval(digioPollingIntervalRef.current);
                    digioPollingIntervalRef.current = undefined;
                }
                setShowInProgressCard(false);
                // navigate to next step
                setShowSuccessCard(true);
                const nextStepId = response?.data?.updatedApplicationObj?.currentStepId;
                if (nextStepId && nextStepId !== 'KYC_DOCUMENTS') {
                    setNextStepId(nextStepId);
                    // navigation.navigate(nextStepId);
                }
            }
            setCTALoader(false);
        } catch (error: any) {
            clearInterval(digioPollingIntervalRef.current);
            setShowInProgressCard(false);
            if (handleApiErr(error)) {
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                    errorHeading: KYC_ERROR_MAP[error?.data?.voltErrorCode].failedTitle || error?.data?.header || "Verification failed!",
                    showErrorHeading: true,
                    btnName: 'Ok, got it!',
                }))
            }
            setCTALoader(false);
        }
    }

    const invokeDigioForWeb = (requestId: string, identifier: string, tokenId: string) => {
        const successCallback = async () => {
            await successCallBackDSP()
        }
        const failureCallback = (error?: any) => {
            setShowInProgressCard(false);
            setCTALoader(false);
            if (digioPollingIntervalRef.current) {
                clearInterval(digioPollingIntervalRef.current);
                digioPollingIntervalRef.current = undefined;
            }
            if (error?.error_code === "CANCELLED") {
                showCancelledCard()
            }
        };

        ImportScript(
            DIGIO_SCRIPT,
            (...args) => {
                invokeDigio(...args);
                digioUtils.init();
                digioUtils.submit(
                    requestId,
                    identifier,
                    tokenId
                );
            },
            successCallback,
            failureCallback
        );

        // Call immediately first, then start polling every 3 seconds
        // successCallback();
        // digioPollingIntervalRef.current = setInterval(successCallback, 3000);
    };

    //For mobile digio integration
    const options: Object = {
        environment: DIGIO_ENVIRONMENT,
        theme: {
            primaryColor: '#234FDA',
            secondaryColor: '#234FDA',
        },
        is_iframe: true,
        logo: 'https://volt-images.s3.ap-south-1.amazonaws.com/volt-website-header.svg',
        fontFamily: 'Poppins',
        fontUrl:
            'https://fonts.googleapis.com/css2?family=Poppins&display=swap',
    }

    const handleKYCCTA = async () => {
        if(errorRetryCount >= 3) {
            trackEvent('KYC_DIGIO_MAX_RETRY_LIMIT_REACHED')

            setErrorRetryCount(0)
            dispatch(
                showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: 'We are facing some issue with our technical systems, please try again later.',
                    closeOnBackdropPress: true,
                    errorHeading : "Service temporarily unavailable",
                    errorType: 'MAX_RETRY_LIMIT_REACHED',
                    routeName: route?.name,
                    ctaLabel: 'Okay'
                }),
            );
            return;
        }
        setCTALoader(true)
        setShowInProgressCard(true)
        const applicationId = await AsyncStorage.getItem('application_id') ?? currentApplicationId
        let kycInitiateResponse;
        try {
            kycInitiateResponse =
                lenderId === LENDER_ID.DSP.toUpperCase()
                    ? await kycDSPInitiate({ applicationId: applicationId })
                    : await kycTATAInitiate({ applicationId: applicationId })
        } catch (error: any) {
            setErrorRetryCount((prevCount) => prevCount + 1);
            setCTALoader(false);
            if (handleApiErr(error)) {
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                    routeName: route?.name,
                    errorHeading: error?.data?.header,
                    ctaLabel: 'Ok, got it'
                }))
            }
        }
        if (kycInitiateResponse?.status === 200) {
            setErrorRetryCount(0)
            if (lenderId === LENDER_ID.DSP.toUpperCase()) {
                const stepResponseObject = kycInitiateResponse?.data?.stepResponseObject
                const identifier = stepResponseObject?.identifier;
                const requestId = stepResponseObject?.requestId;
                const tokenId = stepResponseObject?.tokenId;
                if (Platform.OS === 'web') {
                    invokeDigioForWeb(requestId, identifier, tokenId);
                } else {
                    setShowInProgressCard(false)
                    setDigioInitResponseTokens({
                        identifier: identifier,
                        requestId: requestId,
                        tokenId: tokenId
                    })
                }
                digioInvokedRef.current = false;
                // setShowInProgressCard(false)
            } else if (lenderId === LENDER_ID.TATA.toUpperCase()) {
                const kycTATAURL = await kycTATAInitiateURL({ applicationId });
                const uri = kycTATAURL?.data?.stepResponseObject?.uri;

                if (Platform.OS === 'web') {
                    let pollInterval: number | undefined;
                    let statusInterval: number | undefined;
                    let tempPop: Window | null = null;
                    const params = getParameters(window.location.href);
                    const isFromiOSSDK = params?.isFromiOSSdk;
                    const isFromRnSdk = params?.isFromRnSdk;
                    const platform = params.platform;
                    const allowedOrigins = [
                        'https://app.staging.voltmoney.in',
                        'https://test.staging.voltmoney.in',
                        'https://qa.staging.voltmoney.in',
                        'https://app.voltmoney.in'
                    ];

                    const openPopup = (target: string) => window.open(uri, target, 'width=800,height=600');

                    const handleMessage = (event: MessageEvent) => {
                        if (platform === "PHONEPE" || isFromRnSdk || platform === "ZYPE") {
                            if (event?.data === "stopLoader") {
                                console.warn("EVENT RECEIVED FOR STOPPING LOADER");
                                clearInterval(pollInterval);
                                setShowKYCErrorCard(true);
                            }
                            console.log('Message received from React Native (window):', event.data);
                        } else if (allowedOrigins.includes(event.origin)) {
                            // Handle the received message for web/iOS
                            console.log('Received message:', event.data, event);
                            if (event) {
                                tempPop!.location.href = uri;
                            }
                        } else {
                            console.warn('Received message from unknown origin:', event.origin);
                        }
                    };

                    if (isFromRnSdk || platform === "ZYPE" || platform === "PHONEPE") {
                        tempPop = openPopup(platform === "PHONEPE" ? '_blank' : '_parent');
                        window.addEventListener('message', handleMessage);
                    } else {
                        tempPop = openPopup(isFromiOSSDK ? '_parent' : 'PopupWindowName');
                        tempPop?.addEventListener('message', handleMessage as EventListener, false);
                    }
                    const pollTATAStatus = async () => {
                        try {
                            const statusResponse = await kycTATAStatus({ applicationId });
                            if (statusResponse?.status === 200) {
                                const stepResponseObject = statusResponse?.data?.stepResponseObject?.status;
                                if (tempPop && tempPop.closed && !Object.keys(KYC_RESPONSE_STATUS).includes(stepResponseObject)) {
                                    clearInterval(pollInterval);
                                    clearInterval(statusInterval);
                                    setFailedTitle(failedTitle || "KYC Verification cancelled");
                                    setFailedSubTitle(failedSubTitle || "You closed the verification window before completing KYC. Please try again.");
                                    setShowKYCErrorCard(true);
                                    setShowInProgressCard(false)
                                } else if (stepResponseObject === KYC_RESPONSE_STATUS.COMPLETED || stepResponseObject === KYC_RESPONSE_STATUS.FAILED) {
                                    clearInterval(statusInterval);
                                    clearInterval(pollInterval);
                                    setShowInProgressCard(false)
                                    if (tempPop && !tempPop.closed) tempPop.close();
                                    if (stepResponseObject === KYC_RESPONSE_STATUS.COMPLETED) {
                                        setNextStepId(statusResponse.data.updatedApplicationObj.currentStepId)
                                        setShowSuccessCard(true)
                                    } else {
                                        setShowKYCErrorCard(true)
                                    }
                                } else if (tempPop && tempPop.closed && stepResponseObject === KYC_RESPONSE_STATUS.CREATED) {
                                    clearInterval(pollInterval);
                                    clearInterval(statusInterval);
                                    setFailedTitle(failedTitle || "KYC Verification cancelled");
                                    setFailedSubTitle(failedSubTitle || "KYC verification is required for the completion of your loan application");
                                    setShowKYCErrorCard(true);
                                    setShowInProgressCard(false)
                                }
                            }

                        } catch (err) {
                            setShowInProgressCard(false)
                            clearInterval(pollInterval);
                            clearInterval(statusInterval);

                            //@ts-ignore
                            const errorCode = err?.data?.voltErrorCode
                            setShowKYCErrorCard(true)
                            const errorConfig = KYC_ERROR_MAP[errorCode] || KYC_ERROR_MAP.DEFAULT;
                            setFailedTitle(errorConfig?.failedTitle);
                            //@ts-ignore
                            setFailedSubTitle(errorConfig.failedSubTitle);
                            console.error('Polling kycTATAStatus failed:', err);
                        }
                    };

                    // Call immediately first, then start polling every 3 seconds
                    pollTATAStatus();
                    statusInterval = window.setInterval(pollTATAStatus, 3000);

                    // Store interval reference for cleanup
                    statusIntervalRef.current = statusInterval;
                } else {
                    //open popup in mobile in TATA KYC
                    setShowInProgressCard(false)
                    setDigioInitResponseTokens({
                        uri: uri
                    })
                    const pollTATAStatus = async () => {
                        try {
                            const statusResponse = await kycTATAStatus({ applicationId });
                            if (statusResponse?.status === 200) {
                                const stepResponseObject = statusResponse?.data?.stepResponseObject?.status;
                                // if (tempPop && tempPop.closed && !Object.keys(KYC_RESPONSE_STATUS).includes(stepResponseObject)) {
                                //     clearInterval(pollInterval);
                                //     clearInterval(statusInterval);
                                //     setFailedTitle(failedTitle || "KYC Verification cancelled");
                                //     setFailedSubTitle(failedSubTitle || "You closed the verification window before completing KYC. Please try again.");
                                //     setShowKYCErrorCard(true);
                                //     setShowInProgressCard(false)
                                // } else 

                                if (stepResponseObject === KYC_RESPONSE_STATUS.COMPLETED || stepResponseObject === KYC_RESPONSE_STATUS.FAILED) {
                                    // clearInterval(statusInterval);
                                    // clearInterval(pollInterval);
                                    clearInterval(statusIntervalTATA);
                                    setDigioInitResponseTokens(null);
                                    setShowInProgressCard(false);
                                    // if (tempPop && !tempPop.closed) tempPop.close();
                                    if (stepResponseObject === KYC_RESPONSE_STATUS.COMPLETED) {
                                        setNextStepId(statusResponse.data.updatedApplicationObj.currentStepId)
                                        setShowSuccessCard(true)
                                    } else {
                                        setShowKYCErrorCard(true)
                                    }
                                } else if (stepResponseObject === KYC_RESPONSE_STATUS.CREATED) {
                                    // clearInterval(pollInterval);
                                    // clearInterval(statusInterval);
                                    // clearInterval(statusIntervalTATA);
                                    // setDigioInitResponseTokens(null);
                                    // setShowInProgressCard(false);
                                    // setFailedTitle(failedTitle || "KYC Verification cancelled");
                                    // setFailedSubTitle(failedSubTitle || "KYC verification is required for the completion of your loan application");
                                    // setShowKYCErrorCard(true);
                                }
                            }

                        } catch (err) {
                            setShowInProgressCard(false)
                            clearInterval(statusIntervalTATA);
                            // clearInterval(pollInterval);
                            // clearInterval(statusInterval);
                            setDigioInitResponseTokens(null);
                            //@ts-ignore
                            const errorCode = err?.data?.voltErrorCode
                            setShowKYCErrorCard(true)
                            const errorConfig = KYC_ERROR_MAP[errorCode] || KYC_ERROR_MAP.DEFAULT;
                            setFailedTitle(errorConfig?.failedTitle);
                            //@ts-ignore
                            setFailedSubTitle(errorConfig.failedSubTitle);
                        }
                    };
                    // Poll TATA KYC status every 3 seconds
                    statusIntervalTATA = setInterval(() => {
                        pollTATAStatus();
                    }, 3000);
                }
            }
        } else {
            // setErrorMessage(kycInitiateResponse?.data?.message || "Verification failed. Please try again.");
            // setShowKYCErrorCard(true);
            setShowInProgressCard(false)
        }
    }




    const renderDigioMobileDSP = () => {
        return digioInitResponse && (
            <BottomSheetContainer
                isVisible={digioInitResponse}
                close={() => {
                    setCTALoader(false);
                    setShowInProgressCard(false);
                    setDigioInitResponseTokens(null);
                    showCancelledCard();
                }}
                onClose={() => {
                    setCTALoader(false);
                    setShowInProgressCard(false);
                    setDigioInitResponseTokens(null);
                }}
                dragComponent={undefined}
                closeOnBackdropPress={false}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
                showCloseIcon={true}
                containerStyle={{ backgroundColor: '#fefefe' }}
            >
                {/* @todo: remove height after modal height issue fixed*/}
                <ThemedView height={Platform.OS === 'android' ? '95%' : Dimensions.get('screen').height - 120} marginTop='lg'>
                    <DigioMobileIntegration
                        digioDocumentId={digioInitResponse?.requestId!}
                        digioToken={digioInitResponse?.tokenId!}
                        identifier={digioInitResponse?.identifier!}
                        options={options}
                        onSuccess={(response) => {
                            if (response?.type?.toUpperCase() === "SUCCESS") {
                                setDigioInitResponseTokens(null);
                                successCallBackDSP();
                            }
                        }}
                        onCancel={(response) => {
                            //response comes as undefined in case of success
                            if (response) {
                                setDigioInitResponseTokens(null);
                                setShowInProgressCard(false);
                                setCTALoader(false);
                            }
                        }}
                    />
                </ThemedView>
            </BottomSheetContainer>
        )
    }

        const handleWebViewMessage = async (event) => {


            console.log("Message received from iframe:", event.data);

            let data

            try {
                data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;

                console.log("Converted data is", data.status)

                if (data.success !== false) {
                    setFrameUrl("")

                    try {
                        const response = await kycDSPV2Status({
                            applicationId: userDetails?.linkedApplications[0]?.applicationId
                        });
                        const status = response?.data?.stepResponseObject;
                        if (status === KYC_RESPONSE_STATUS.COMPLETED) {
                            if (digioPollingIntervalRef.current) {
                                clearInterval(digioPollingIntervalRef.current);
                                digioPollingIntervalRef.current = undefined;
                            }
                            setShowInProgressCard(false);
                            // navigate to next step
                            setShowSuccessCard(true);
                            const nextStepId = response?.data?.updatedApplicationObj?.currentStepId;
                            if (nextStepId && nextStepId !== 'KYC_DOCUMENTS') {
                                setNextStepId(nextStepId);
                                // navigation.navigate(nextStepId);
                            }
                        }
                        setCTALoader(false);
                    } catch (error: any) {
                        clearInterval(digioPollingIntervalRef.current);
                        setShowInProgressCard(false);
                        if (handleApiErr(error)) {
                            dispatch(showErrorSheet({
                                isErrorSheetVisible: true,
                                errorMessage: error?.data?.message,
                                closeOnBackdropPress: true,
                                errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                                errorHeading: error?.data?.header,
                                showErrorHeading: true,
                                btnName: 'Ok, got it!',
                            }))
                        }
                        setCTALoader(false);
                        console.error('Polling error:', error);
                    }
                    // navigation.navigate(ROUTE.KYC_DIGIO_REDIRECT)

                    // fetchKYCRedirectStatus()

                }



                if (event.data.type === "customEvent") {
                    console.log("Custom event data:", event.data.payload);
                }

            } catch (error) {

            }


        };


    

    const renderDigioMobileTATA = () => {
        return digioInitResponse && (
            <BottomSheetContainer
                isVisible={digioInitResponse}
                close={() => {
                    setCTALoader(false);
                    setShowInProgressCard(false);
                    setDigioInitResponseTokens(null);
                    clearInterval(statusIntervalTATA);
                    showCancelledCard();
                }}
                onClose={() => {
                    setCTALoader(false);
                    setShowInProgressCard(false);
                    clearInterval(statusIntervalTATA);
                    setDigioInitResponseTokens(null);
                }}
                dragComponent={undefined}
                closeOnBackdropPress={false}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
                showCloseIcon={true}
                containerStyle={{ backgroundColor: '#fefefe' }}
            >
                {/* @todo: remove height after modal height issue fixed*/}
                <ThemedView height={Platform.OS === 'android' ? '95%' : Dimensions.get('screen').height - 120} marginTop='lg'>
                    <WebView
                        style={{
                            width: '100%',
                            height: '100%'
                        }}
                        source={{ uri: digioInitResponse?.uri }}
                        javaScriptEnabled={true}
                        domStorageEnabled={true}
                        originWhitelist={['*']}
                        automaticallyAdjustContentInsets={false}
                        useWebKit={true}
                        allowsInlineMediaPlayback
                        scalesPageToFit={Platform.OS === 'android'}
                        scrollEnabled={true}
                        mediaPlaybackRequiresUserAction={false}
                        javaScriptEnabledAndroid
                        showsHorizontalScrollIndicator={false}
                        nestedScrollEnabled={Platform.OS !== "web"}
                    />
                </ThemedView>
            </BottomSheetContainer>
        )
    }

    return (
        <ScreenWrapper screenName={route?.name} additionalProperties={{ newArchRoute: true }}>
            {stepperLoading || isPageLoading ?
                <PageLoader />
                :
                <ThemedView flex={1}>
                    <CommonHeader label='KYC verification' navigation={navigation} pageName={route.name}
                        hideBottomBorder={true} />
                    <Stepper stepperData={stepperData} />
                       {frameUrl || deepcheckApiInProgress ? <ThemedView backgroundColor="bg-surface-primary" justifyContent='center' flex={1} >
                {deepcheckApiInProgress ? <ActivityIndicator size={'small'} />
                    : (Platform.OS === 'web' ?
                        <iframe
                            style={{ flex: 1, borderWidth: 0 }}
                            
                            src={frameUrl}
                            allow="camera; microphone; autoplay"

                        ></iframe>
                        :
                        <WebView
                            style={{
                                width: '100%',
                                height: '100%'
                            }}
                            source={{ uri: frameUrl }}
                            javaScriptEnabled={true}
                            domStorageEnabled={true}
                            originWhitelist={['*']}
                            onMessage={(ev) => {
                                handleWebViewMessage(ev.nativeEvent);
                            }}
                            automaticallyAdjustContentInsets={false}
                            useWebKit={true}
                            allowsInlineMediaPlayback
                            scalesPageToFit={Platform.OS === 'android'}
                            scrollEnabled={true}
                            mediaPlaybackRequiresUserAction={false}
                            javaScriptEnabledAndroid
                            showsHorizontalScrollIndicator={false}
                        />)}
            </ThemedView>

                        : <ThemedView backgroundColor="bg-surface-primary" flex={1}>
                            <ThemedView padding={'lg'} mt={'sm'}>
                                <ThemedText color="text-primary" variant="h5s">
                                    {"Instant KYC via DigiLocker"}
                                </ThemedText>
                                <ThemedView borderRadius={'sm'} borderWidth={1} borderColor={"border-primary"}
                                    padding={"lg"}
                                    mt={"lg"}>
                                    <DigiLockerIcon />
                                    <ThemedText variant={"b4m"} mt={"lg"} color={"text-secondary"}>
                                        Digilocker benefits
                                    </ThemedText>
                                    <ThemedView flexDirection={'row'} mt={"md"} alignItems={"center"}>
                                        <KYCFastSecure />
                                        <ThemedText ml={"sm"} variant={"b4r"} color={"text-secondary"}>Fast & secure way to
                                            share
                                            documents</ThemedText>
                                    </ThemedView>
                                    <ThemedView flexDirection={'row'} mt={"md"} alignItems={"center"}>
                                        <KYCInstantAadharPull />
                                        <ThemedText ml={"sm"} variant={"b4r"} color={"text-secondary"}>Instantly pull
                                            Aadhaar &
                                            PAN</ThemedText>
                                    </ThemedView>
                                    <ThemedView flexDirection={'row'} mt={"md"} alignItems={"center"}>
                                        <KYCGovtOfIndia />
                                        <ThemedText ml={"sm"} variant={"b4r"} color={"text-secondary"}>Developed by
                                            Government of
                                            India</ThemedText>
                                    </ThemedView>
                                </ThemedView>
                            </ThemedView>

                            <ThemedView justifyContent={'flex-end'} bottom={0} flex={1} mt={"sm"}>
                                <ThemedView justifyContent={"flex-end"} borderTopWidth={1} borderColor={"border-primary"} />

                                <ThemedView padding={"lg"}>
                                    <Button
                                        eventName='KYC_DOCUMENTS_PROCEED_WITH_DIGILOCKER'
                                        label="Proceed with DigiLocker"
                                        type="SOLID"
                                        size='MD'
                                        disabled={false}
                                        handlePress={handleKYCCTA}
                                        bg={'#1434CB'}
                                        textColor={colors['text-primary']}
                                        buttonLoader={ctaLoader}
                                    />
                                    <ThemedText textAlign='center' variant='b4r' color='text-secondary' mt={'sm'}>
                                        {`By proceeding, I consent to share my KYC documents with ${lenderInfo?.data?.lenderName} and consent to camera access for KYC completion.`}
                                    </ThemedText>
                                </ThemedView>

                            </ThemedView>
                        </ThemedView>}
                </ThemedView>
            }
            {showKYCErrorCard && (
                <KYCErrorCard
                    visible={showKYCErrorCard}
                    onClose={() => {
                        setShowKYCErrorCard(false);
                        setCTALoader(false);
                        setFailedTitle(undefined);
                        setFailedSubTitle(undefined);
                        setErrorMessage('');
                    }}
                    failedTitle={failedTitle}
                    failedSubTitle={failedSubTitle}
                    errorMessage={errorMessage}
                />
            )}
            {showInProgressCard && (
                <InProgressCard
                    visible={showInProgressCard}
                    onClose={() => setShowInProgressCard(false)}
                    colors={colors}
                />
            )}
            {showSuccessCard && successLottie && (
                <SuccessCard
                    visible={showSuccessCard}
                    onClose={() => setShowSuccessCard(false)}
                    lottieSource={successLottie}
                    colors={colors}
                    onContinueClick={handleContinueClick}
                />
            )}
            {Platform.OS !== 'web' && lenderId === LENDER_ID.DSP.toUpperCase() ? renderDigioMobileDSP() : renderDigioMobileTATA()}
        </ScreenWrapper>
    )
}

export default KYCDocuments